import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "ui-page" }
const _hoisted_2 = { class: "titlebar" }
const _hoisted_3 = { class: "titlebar-content" }
const _hoisted_4 = { class: "titlebar-title --mobile" }
const _hoisted_5 = { class: "titlebar-text" }
const _hoisted_6 = { class: "titlebar-actions" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "titlebar-actions-secondary" }, null, -1)
const _hoisted_8 = { class: "titlebar-actions-primary" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Salvar")
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "ui-card" }
const _hoisted_12 = { class: "ui-card-body" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-lg-4 ant-col-xl-3" }
const _hoisted_15 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-lg-5 ant-col-xl-5"
}
const _hoisted_16 = {
  key: 1,
  class: "ant-col ant-col-xs-24 ant-col-lg-5 ant-col-xl-5"
}
const _hoisted_17 = {
  key: 2,
  class: "ant-col ant-col-xs-24 ant-col-lg-21 ant-col-xl-21"
}
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-lg-3 ant-col-xl-3" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-lg-6 ant-col-xl-10" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-lg-12 ant-col-xl-14" }
const _hoisted_22 = { class: "ant-row" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-lg-24 ant-col-xl-24" }
const _hoisted_24 = { class: "ant-row" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_28 = { class: "ant-row" }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_combo_tipo_documento = _resolveComponent("combo-tipo-documento")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_cpf = _resolveComponent("campo-cpf")!
  const _component_campo_cnpj = _resolveComponent("campo-cnpj")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_campo_telefone = _resolveComponent("campo-telefone")!
  const _component_campo_email = _resolveComponent("campo-email")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_campo_cep = _resolveComponent("campo-cep")!
  const _component_combo_cidade = _resolveComponent("combo-cidade")!
  const _component_card = _resolveComponent("card")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.appBase.titulo), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "ui-button -primary",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.salvar()))
          }, _hoisted_10)
        ])
      ])
    ]),
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.appBase.carregando
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_card, { titulo: "" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_a_form_item, { label: "Documento" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_combo_tipo_documento, {
                              valor: _ctx.state.pessoa.tipoDocumento,
                              "onUpdate:valor": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.pessoa.tipoDocumento) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]),
                      (_ctx.state.pessoa.tipoDocumento === _ctx.ETipoDocumento.CPF)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createVNode(_component_a_form_item, { label: "Número" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_cpf, {
                                  valor: _ctx.state.pessoa.numeroDocumento,
                                  "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.pessoa.numeroDocumento) = $event))
                                }, null, 8, ["valor"])
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.pessoa.tipoDocumento === _ctx.ETipoDocumento.CNPJ)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createVNode(_component_a_form_item, { label: "Número" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_cnpj, {
                                  valor: _ctx.state.pessoa.numeroDocumento,
                                  "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.pessoa.numeroDocumento) = $event)),
                                  onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.consultaDocumento()))
                                }, null, 8, ["valor"])
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.state.pessoa.tipoDocumento === _ctx.ETipoDocumento.CPF?'ant-col ant-col-xs-24 ant-col-lg-13 ant-col-xl-13':'ant-col ant-col-xs-24 ant-col-lg-16 ant-col-xl-16')
                      }, [
                        _createVNode(_component_a_form_item, {
                          label: _ctx.state.pessoa.tipoDocumento === _ctx.ETipoDocumento.CPF?'Nome':'Razão Social/Nome da Empresa'
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.pessoa.nome) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.pessoa.nome]
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ], 2),
                      (_ctx.state.pessoa.tipoDocumento === _ctx.ETipoDocumento.CNPJ)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createVNode(_component_a_form_item, { label: "Contato" }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.pessoa.contato) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.pessoa.contato]
                                ])
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_a_form_item, { label: "Ativa" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_sim_nao, {
                              "radio-button": true,
                              valor: _ctx.state.pessoa.status,
                              "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.pessoa.status) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_a_form_item, { label: "Telefone Principal" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_telefone, {
                              valor: _ctx.state.pessoa.telefone,
                              "onUpdate:valor": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.pessoa.telefone) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_a_form_item, { label: "E-mail" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_email, {
                              valor: _ctx.state.pessoa.email,
                              "onUpdate:valor": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.pessoa.email) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_a_form_item, { label: "Observações" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_textarea, {
                              rows: 6,
                              placeholder: "Digite aqui",
                              value: _ctx.state.pessoa.observacao,
                              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.pessoa.observacao) = $event))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    (_ctx.UtilitarioGeral.validaLista(_ctx.state.pessoa.enderecos))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createVNode(_component_a_form_item, { label: "CEP" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_campo_cep, {
                                    onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.consultaCep())),
                                    valor: _ctx.state.pessoa.enderecos[0].cep,
                                    "onUpdate:valor": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.pessoa.enderecos[0].cep) = $event))
                                  }, null, 8, ["valor"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_a_form_item, { label: "Endereço/Logradouro" }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "ant-input",
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.pessoa.enderecos[0].enderecoCompleto) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.state.pessoa.enderecos[0].enderecoCompleto]
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                              _createVNode(_component_a_form_item, { label: "Número" }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "ant-input",
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.pessoa.enderecos[0].numero) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.state.pessoa.enderecos[0].numero]
                                  ])
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createVNode(_component_a_form_item, { label: "Complemento" }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "ant-input",
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.pessoa.enderecos[0].complemento) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.state.pessoa.enderecos[0].complemento]
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _createVNode(_component_a_form_item, { label: "Bairro" }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "ant-input",
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.pessoa.enderecos[0].bairro) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.state.pessoa.enderecos[0].bairro]
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                              _createVNode(_component_a_form_item, { label: "Cidade/UF" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_combo_cidade, {
                                    codigo: _ctx.state.pessoa.enderecos[0].codigoCidade,
                                    "onUpdate:codigo": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.pessoa.enderecos[0].codigoCidade) = $event))
                                  }, null, 8, ["codigo"])
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}